module.exports = __webpack_public_path__ + "static/media/Elizabeth_Kim_DDS.4b4afff3.jpg";